import qs from 'qs';
import client from './client';

const url = '/api/v1/project/group';

export const getGroups = (searchData) =>
  client.get(`${url}/list?${qs.stringify(searchData || {})}`);

export const getGroup = (groupUuid) => client.get(`${url}/info/${groupUuid}`);

export const addGroup = (body) => client.post(`${url}/info`, body);

export const editGroup = (groupUuid, body) => client.put(`${url}/info/${groupUuid}`, body);

// 지우기 전에 몇 건의 소속이 풀리는지 물어본다
export const getGroupChanceCount = (groupUuid) =>
  client.get(`${url}/info/${groupUuid}/chance-count`);

export const removeGroup = (groupUuid) => client.delete(`${url}/info/${groupUuid}`);

// 기회 한 건의 소속 변경. groupUuid 를 비워 보내면 소속을 푼다.
export const assignChance = (prjUuid, groupUuid) =>
  client.put(`${url}/assign/${prjUuid}`, { groupUuid: groupUuid || '' });
